const formatRegex = /(\d)(?=(\d{3})+(?!\d))/g;

/**
 * 
 * Receive a Num in String formmat without dots and commas, and return with the correct format
 * 
 * @param {String} num 
 * @param {String} tousandsSeparator 
 * @param {String} decimalSeparator 
 * @param {Int} decimalLength 
 * @param {Bool} showDecimalsEqualsToCero 
 * @param {Bool} afterOperation 
 */

const GetFormatedNumber = (
  num,
  tousandsSeparator = '.',
  decimalSeparator = ',',
  decimalLength = 2,
  showDecimalsEqualsToCero = false,
  afterOperation = false,
) => {
  let intNum;
  let decimalNum = '';
  if (num.includes(decimalSeparator)) {
    const completeNum = num.split(decimalSeparator);
    intNum = completeNum[0];

    for (let i = 1; i <= completeNum.length - 1; i++) {
      decimalNum = decimalNum + '' + completeNum[i];
    }

    intNum = intNum.replace(/[.,]/g, '');
    decimalNum = decimalNum.replace(/[.,]/g, '');

    if (!showDecimalsEqualsToCero && decimalNum.length > (decimalLength - 1)) {
      decimalNum = parseInt(decimalNum, 10) > 0 ? decimalNum : '';
    }

    if (afterOperation) {
      const decimalStringPart = `${decimalSeparator}${decimalNum.slice(0, decimalLength)}`
      return `${intNum.replace(formatRegex, "$1" + tousandsSeparator)}${(showDecimalsEqualsToCero || decimalNum !== '') ? decimalStringPart : ''}` ;
    }

    return intNum.replace(formatRegex, "$1" + tousandsSeparator) + decimalSeparator + decimalNum.slice(0, decimalLength);

  }

  num =  num.replace(/[.,]/g, '');
  return num.toString().replace(formatRegex, "$1" + tousandsSeparator);
};

export default GetFormatedNumber;